import { Modal } from 'semantic-ui-react'
import { useBooleanState, t, I18nHtml } from 'shared'
import classNames from 'classnames'

export const SearchRankingModal = ({ className }: { className?: string }) => {
  const [open, setOpen, setClose] = useBooleanState(false)

  return (
    <Modal
      onClose={setClose}
      open={open}
      trigger={
        <button onClick={setOpen} className={classNames(className, 'text-me-purple-600 hover:underline')}>
          {t('campaign.search_results_note')}
        </button>
      }
      closeIcon
    >
      <Modal.Content>
        <h2>{t('campaign.search_ranking_modal_title')}</h2>
        <I18nHtml i18nKey="campaign.search_ranking_modal_html" />
      </Modal.Content>
    </Modal>
  )
}
